import Chart from "react-apexcharts";
import '../../../../cssfiles/homepage.css';
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function MixedIndividual(props) {
    const tagcollectionvalue = useSelector((state) => state.mainpagedata.tagcollectionvalues);
    //console.log("MixedIndividual inside mixed chart**********************tagcollectionvaluedgfngfngfngf********************", tagcollectionvalue);
    const theme = useSelector((state) => state.themedata.theme)
    
    const  datavalues = ["All","Even","Odd"];
    const [selectedValueOption, setSelectedValueOption] = useState('All'); 
    const [selectedValue, setSelectedValue] = useState("option1"); 

    const handleChange = (event) => { 
        setSelectedValueOption(event.target.value);
       // //console.log("funnel--event.target.value",event.target.value)
        if(event.target.value=='All'){
            setSelectedValue("option1"); 
        }else if(event.target.value=='Even'){
            setSelectedValue("option2"); 
        }else if(event.target.value=='Odd'){
            setSelectedValue("option3"); 
        }
        
    }

    const [seriesChart, setSeriesChart] = useState([]);
    const [options, setOptions] = useState({});
    const color_map = new Map();
    const chart_map = new Map();

    useEffect(() => {
        var color_map = new Map();
        var chart_map = new Map();

        if (!tagcollectionvalue || Object.keys(tagcollectionvalue).length === 0) {
            //console.log("tagcollectionvalue is not available yet.");
            return;
        }else{

            var tagProperties = props.widgetprop.props.extended.tagprops;
            var colorPropertiesLines = [];
            var widthPropertiesLines = [];
            var curvePropertiesLines = [];
            var legendNamePropertiesLines = [];

            var colorPropertiesBars = [];
            var widthPropertiesBars = [];
            var curvePropertiesBars = [];
            var legendNamePropertiesBars = [];

            var phasesobject = {};
            var targetconfigvalue = 0;
            var targetconfigname = '';
            let isBarHorizontal = false;
            var seriesarray = {};
            tagProperties.forEach(chartType => {
                
                if (tagcollectionvalue.hasOwnProperty(chartType.tagid)) {
                    // //console.log("chartType.tagid in mixed indi odd",chartType.tagid)
                    var tagValues = tagcollectionvalue[chartType.tagid];
                    // //console.log("tagValues in ihr",tagValues)
                    var tagPhase = "";
                    if( chartType.phase !== ""){
                        tagPhase = chartType.phase
                    }

                    if(chartType.charttype == 'bar'){
                        
                    }else if(chartType.charttype == 'line'){
                        colorPropertiesLines.push(chartType.chartprops.color);
                        widthPropertiesLines.push(2);
                        curvePropertiesLines.push('smooth');
                        legendNamePropertiesLines.push(chartType.legendname);
                        //console.log("chartType.phase line",chartType.phase,"legendNamePropertiesLines",legendNamePropertiesLines,"chartType.orderofchart",chartType.orderofchart)
                    }

                    if (chartType.isTarget == false) {
                        var sum=0.0;
                        if(Array.isArray(tagValues) && tagValues.length > 0){
                            for(var j=0;j<tagValues.length;j++){
                                sum = sum + Number(tagValues[j]?.y ?? 0)
                            }
                        }
                        
                        if(seriesarray.hasOwnProperty(tagPhase)){
                            var datacurrent = {x:chartType.orderofchart, y:sum}
                            //var datacurrentarray =seriesarray[tagPhase].data;
                            if(selectedValue == "option1"){
                                seriesarray[tagPhase].data.push(datacurrent)
                            }else if(selectedValue == "option2"){
                                if(Number(chartType.orderofchart) % 2 == 0){
                                    seriesarray[tagPhase].data.push(datacurrent)
                                }
                            }else if(selectedValue == "option3"){
                                if(Number(chartType.orderofchart) % 2 != 0){
                                    seriesarray[tagPhase].data.push(datacurrent)
                                }
                            }
                            
                        }else{
                            color_map.set(chartType.phase, chartType.chartprops.color);
                            chart_map.set(chartType.phase, chartType.charttype);

                            isBarHorizontal = chartType.chartprops.horizontal;

                            var datacurrent = {x:chartType.orderofchart, y:sum}
                            var currentarray = [];
                            currentarray.push(datacurrent);

                            if(selectedValue == "option1"){
                                seriesarray[tagPhase] = { name:'', type:'',data:[]};
                                seriesarray[tagPhase] = {
                                    name: tagPhase,
                                    type:chartType.charttype,
                                    data: currentarray,
                                
                                }

                                colorPropertiesBars.push(chartType.chartprops.color);
                                widthPropertiesBars.push(2);
                                curvePropertiesBars.push('smooth');
                                legendNamePropertiesBars.push(chartType.legendname);
                                //console.log("chartType.phase bar",chartType.phase,"legendNamePropertiesBars",legendNamePropertiesBars,"chartType.orderofchart",chartType.orderofchart)
                               
                            }else if(selectedValue == "option2"){
                                if(Number(chartType.orderofchart) % 2 == 0){
                                    seriesarray[tagPhase] = { name:'', type:'',data:[]};
                                    seriesarray[tagPhase] = {
                                        name: tagPhase,
                                        type:chartType.charttype,
                                        data: currentarray,
                                    }
                                    colorPropertiesBars.push(chartType.chartprops.color);
                                    widthPropertiesBars.push(2);
                                    curvePropertiesBars.push('smooth');
                                    legendNamePropertiesBars.push(chartType.legendname);
                                    //console.log("chartType.phase bar",chartType.phase,"legendNamePropertiesBars",legendNamePropertiesBars,"chartType.orderofchart",chartType.orderofchart)
                                   
                                }
                            }else if(selectedValue == "option3"){
                                if(Number(chartType.orderofchart) % 2 != 0){
                                    seriesarray[tagPhase] = { name:'', type:'',data:[]};
                                    seriesarray[tagPhase] = {
                                        name: tagPhase,
                                        type:chartType.charttype,
                                        data: currentarray,
                                    
                                    }
                                    colorPropertiesBars.push(chartType.chartprops.color);
                                    widthPropertiesBars.push(2);
                                    curvePropertiesBars.push('smooth');
                                    legendNamePropertiesBars.push(chartType.legendname);
                                    //console.log("chartType.phase bar",chartType.phase,"legendNamePropertiesBars",legendNamePropertiesBars,"chartType.orderofchart",chartType.orderofchart)
                                   
                                }
                            }
                        }
                    }
        
                }})
            //console.log("seriesarray in mixed individ",seriesarray)
            var serieschartcurrent = [];
            for(let keydata in seriesarray){
                serieschartcurrent.push(seriesarray[keydata])
            }

            // const yaxisProperties = tagProperties.map(chartType => {
            //     if (chartType.charttype !== "maxlimit" && chartType.charttype !== "minlimit") {
            //         return {
            //             show: false,
            //             seriesName: chartType.seriesnameassociated ?? "",
            //             forceNiceScale: true,
            //             labels: {
            //                 show: true,
            //                 style: {
            //                     colors: 'var(--axis-color)',
            //                     fontSize: props.widgetprop.props.extended.fontsize,
            //                     fontFamily: props.widgetprop.props.extended.fontfamily,
            //                     fontWeight: props.widgetprop.props.extended.fontweight,
            //                 },
            //                 formatter: (value) => { return value.toFixed(2); },
            //             },
            //             title: {
            //                 text: chartType.yaxis_title.titlename ?? "",
            //                 style: {
            //                     color: 'var(--axis-title-color)',
            //                     fontSize: props.widgetprop.props.extended.title.fontsize,
            //                     fontFamily: props.widgetprop.props.extended.title.fontfamily,
            //                     fontWeight: props.widgetprop.props.extended.title.fontweight,
            //                 },
            //             },
            //         };
            //     }
            //     return null;
            // }).filter(item => item !== null);

            const yaxisProperties = {
                show: true,
                seriesName: tagProperties[0].seriesnameassociated ?? "",
                forceNiceScale: false,
                labels: {
                    show: true,
                    style: {
                        colors: 'var(--axis-color)',
                        fontSize: props.widgetprop.props.extended.fontsize,
                        fontFamily: props.widgetprop.props.extended.fontfamily,
                        fontWeight: props.widgetprop.props.extended.fontweight,
                    },
                    formatter: (value) => { return value.toFixed(2); },
                },
                title: {
                    text: tagProperties[0].yaxis_title.titlename ?? "",
                    offsetX: 10,
                    style: {
                        color: 'var(--axis-title-color)',
                        fontSize: props.widgetprop.props.extended.title.fontsize,
                        fontFamily: props.widgetprop.props.extended.title.fontfamily,
                        fontWeight: props.widgetprop.props.extended.title.fontweight,
                    },
                },
            };

            const optionsConsumption = {
                chart: {
                    type: "line",
                    toolbar: {
                        show: false
                    },
                    offsetX: -10,
                },
                grid: {
                    show: true,
                    borderColor: 'var(--grey-variation)',
                },
                stroke: {
                    show: true,
                    width: [...widthPropertiesBars, ...widthPropertiesLines],
                    curve: [...curvePropertiesBars, ...curvePropertiesLines],
                },
                fill: {
                    opacity: 1,
                    type: 'solid',
                },
                colors: [...colorPropertiesBars, ...colorPropertiesLines],
                plotOptions: {
                    bar: {
                        columnWidth: '30%',
                        horizontal: isBarHorizontal,
                    }
                },
                xaxis: {
                    tickAmount: serieschartcurrent[0]?.data.length-1,
                    tooltip: {
                        enabled: false
                    },
                    axisBorder: {
                        show: true,
                        color: 'var(--axis-color)',
                    },
                    axisTicks: {
                        show: true,
                        height: 3,
                        color: 'var(--axis-color)',
                    },
                    labels: {
                        show: true,
                        style: {
                            colors: 'var(--axis-color)',
                            fontSize: props.widgetprop.props.extended.fontsize,
                            fontFamily: props.widgetprop.props.extended.fontfamily,
                            fontWeight: props.widgetprop.props.extended.fontweight,
                        },
                    
                    },
                },
                yaxis: yaxisProperties,
                tooltip: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    custom: function({ series, seriesIndex, dataPointIndex, w }) {
                        const value = series[seriesIndex][dataPointIndex];
                        const timestamp = w.globals.seriesX[seriesIndex][dataPointIndex];
                    
                        var currentFormattedDate = new Date(timestamp);
                        
                        var tooltipString = `<div style="display:flex; flex-direction:column; padding:5px; background-color:#005C8E;">`;
                        const options = { 
                            year: 'numeric', 
                            month: '2-digit', 
                            day: '2-digit', 
                            hour: '2-digit', 
                            minute: '2-digit', 
                            hour12: false 
                          }; 
                        var formattedDate = currentFormattedDate.toLocaleDateString('en-US', options).replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g, '$3-$1-$2');;
                        // Begin building the tooltip string
        
                        for (var i = 0; i < series.length; i++) {
                            const seriesValue = series[i][dataPointIndex];
                            tooltipString += `
                            <div style="display:flex; align-items:center; margin-bottom:4px; background-color:#005C8E;">
                                <div style="height:8px; width:8px; background-color:${w.config.colors[i]}; border-radius:50%; margin-right:8px;"></div>
                                <div style="font-weight:600; color:#FFFFFF;">${serieschartcurrent[i].name}</div>
                                <div style="margin-left:12px; color:#FFFFFF;">${(seriesValue == null)?("No Value"):seriesValue.toFixed(2)}</div>
                            </div>
                            `;
                        }
                        tooltipString += `</div>`;
                        return tooltipString;
                    },
                    hideEmptySeries: true,
                    fillSeriesColor: false,
                    theme: false,
                    borderRadius:0,
                    style: {
                      fontSize: "12px",
                      fontWeight: 800,
                      fontFamily: 'Roboto',
                    },
                  },
                legend: {
                    show: true,
                    fontSize: props.widgetprop.props.extended.legend.fontsize,
                    fontFamily: props.widgetprop.props.extended.legend.fontfamily,
                    fontWeight: props.widgetprop.props.extended.legend.fontweight,
                    labels: {
                        colors: Array(colorPropertiesBars.length + colorPropertiesLines.length).fill('var(--legend-text-color)')
                    },
                    customLegendItems: [...legendNamePropertiesBars, ...legendNamePropertiesLines],
                    markers: {
                        radius: props.widgetprop.props.extended.legend.marker.radius,
                        height: props.widgetprop.props.extended.legend.marker.height,
                        width: props.widgetprop.props.extended.legend.marker.width,
                        fillColors: [...colorPropertiesBars, ...colorPropertiesLines]
                    }
                },
            };

            //console.log("serieschartcurrent---MixedIndividual",serieschartcurrent)
            setSeriesChart(serieschartcurrent);
            setOptions(optionsConsumption);

        }
    }, [props.widgetprop, selectedValue, tagcollectionvalue]);

    return (
        <>

            <FormControl>
                    {/*<InputLabel id="yearSelect"  shrink={false} sx={{textAlign:"left",marginRight:"6px",fontSize:'12px', fontFamily:'Roboto',fontWeight:400,marginTop:"-6px",color:"var(--GreyVariation_2)" }}>{label}</InputLabel>*/} 
                        <Select
                            //name="yearSelect" id="yearSelect" labelId="yearSelect" inputlabel="year"  
                            value={selectedValueOption} 
                            onChange={handleChange}
                            defaultValue="Device-Wise"
                            sx={{
                                width:'190px',
                                height: '40px',
                                bgcolor:'var(--SecondaryBackground)',
                                color:'var(--GreyVariation_2)',
                                fontSize:'18px',
                                fontFamily:'Roboto',
                                fontWeight:500,
                                borderBottom:(theme == 'dark')?"2px solid #FFFFFF":"2px solid #000000",
                                textAlign:'left',
                                borderRadius:0,
                                marginRight:'6px',
                                marginLeft:'1000px',
                                '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':{
                                    border:0,
                                },
                                '& .MuiOutlinedInput-notchedOutline ': {
                                    width:'190px',
                                    height:'40px',
                                    border:0,
                                    padding:0
                                },
                                '& .MuiInputLabel-root':{display:'none',legend:'none',paddingTop:"3px",paddingRight:"3px"},
                                '& .MuiSelect-icon':{ color:(theme == 'light')?"#000000":"#FFFFFF",marginLeft:"7px"}	
                            }}
                            InputLabelProps={{shrink: false}}
                            IconComponent={KeyboardArrowDownIcon}
                            MenuProps={{
                                PaperProps:{
                                    sx:{
                                        bgcolor:theme==='dark'?'#3C3C3C':'#C1C1C1',
                                        borderBottom:'2px solid #008CD7',
                                        borderTop:'2px solid #008CD7',
                                        borderRadius:0,
                                        fontSize:'18px',
                                        boxShadow:'none',
                                        maxHeight:'250px',
                                        overflow:'auto',
                                        color:theme==='dark'?'#FFFFFF':'#3C3C3C',
                                    }
                                },               
                            }}

                        >
                            {datavalues.map((period) => {
                                return <MenuItem sx={{fontSize:'16px', fontFamily:'Roboto',fontWeight:400,"& .MuiMenuItem.Mui-selected":{backgroundColor:"#005C8E"}}} value={period}>{period}</MenuItem>
                            })}
                        </Select>
                </FormControl>
            <Chart options={options} series={seriesChart} type="line" height="65%" width="100%" />
        </>
    );
}
